"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpTags = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_i18next_1 = require("react-i18next");
var Common_1 = require("../../Common");
var DpTags_styled_1 = require("./DpTags.styled");
var DpTag_1 = require("./DpTag");
var DpTags = function (_a) {
    var tags = _a.tags, _b = _a.maxToShow, maxToShow = _b === void 0 ? 3 : _b, _c = _a.variant, variant = _c === void 0 ? 'badge' : _c, _d = _a.capitalization, capitalization = _d === void 0 ? 'uppercase' : _d;
    var t = (0, react_i18next_1.useTranslation)('assessment').t;
    /**
     * Creates a list of Tags to display
     */
    var badges = (0, react_1.useMemo)(function () {
        var displayedTags = tags.slice(0, maxToShow);
        if (tags.length > maxToShow && variant === 'badge') {
            displayedTags.push(t('DpTags.badgeMore'));
        }
        return displayedTags.map(function (tag) { return ((0, jsx_runtime_1.jsx)(DpTag_1.DpTag
        // @ts-ignore
        , { transformation: capitalization, children: tag }, tag)); });
    }, [t, variant, maxToShow, tags, capitalization]);
    return ((0, jsx_runtime_1.jsxs)(DpTags_styled_1.StyledTags, { "data-testid": "dpTags", children: [badges, tags.length > maxToShow && variant === 'icon' && (0, jsx_runtime_1.jsx)(Common_1.Icon, { name: "plus" })] }));
};
exports.DpTags = DpTags;
exports.default = exports.DpTags;
